<div class="outreach-container">
  <div class="outreach-card">
    <img src="/assets/images/icons/bigGreentick.svg" alt="" />

    <h2 class="title">Branded Outreach Enabled!</h2>

    <p class="description">
      Your domain is now successfully connected. Recuvery will send recovery communications to your customers directly from
      your business email domain.
    </p>
    <a
      target="_blank"
      href="https://testbusiness.recuvery.com/login"
      class="btn btn-primary p-3 mb-3 fs-5"
      style="background-color: #18b557; max-width: 400px; width: 100%"
    >
      Go to Dashboard
    </a>
  </div>
</div>
